import { clientCardSlice } from '@/features/Client/clientCardSlice'
import { sodApi } from '@/services/index'
// Define a service using a base URL and expected endpoints
export const ApplicationApi = sodApi.injectEndpoints({
  endpoints: (builder) => ({
    saveApplication: builder.mutation({
      query: (formData) => ({
        url: '/Application/Create',
        method: 'POST',
        body: formData,
      }),
    }),
    editApplication: builder.mutation({
      query: ({ applicationId, formData }) => ({
        url: `/Application/Edit/${applicationId}`,
        method: 'POST',
        body: formData,
      }),
    }),
    deleteApplication: builder.mutation({
      query: (applicationId) => ({
        url: `/Application/Delete/${applicationId}`,
        method: 'GET',
      }),
    }),
    listApplication: builder.query<
      any,
      {
        engagementId: string
        query?: string
      }
    >({
      query: ({ engagementId, query }) => {
        const params: Record<string, any> = {}
        if (query) {
          params.query = query
          params.status = query
        }

        return {
          url: `/Application/${engagementId}/List`,
          method: 'GET',
          params,
        }
      },
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled
          dispatch(clientCardSlice.actions.setApplicationList(data))
        } catch (error) {
          console.error('Error fetching application list:', error)
        }
      },
    }),
    listApplicationFilter:  builder.query<any, any>({
      query: ({ engagementId, query }) => ({
        url: `/Application/${engagementId}/list/${query}`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useSaveApplicationMutation,
  useListApplicationQuery,
  useEditApplicationMutation,
  useDeleteApplicationMutation,
  useLazyListApplicationFilterQuery
} = ApplicationApi
